<template>
	<div  class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="gotoOverview()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>E-finder toevoegen</v-toolbar-title>
			<v-btn icon @click="showMenu()">
				<v-icon>menu</v-icon>
			</v-btn>
		</v-toolbar>

		<v-content class="uf-form">

			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>3</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 3 - Koppelen</v-list-tile-title>
						<v-list-tile-sub-title>Koppel je E-finder aan je telefoon</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>

			<v-container class="item-group" mb-4 >

				<h3>Je E-finder is gekoppeld.</h3><br/>

				<p>Nu ben je klaar om je E-finder te gebruiken. Klik hieronder om naar de Kaart te gaan.</p>
				<p>Het kan ongeveer een uur voordat de lokaties op de kaart te zien zijn. Dit is normaal.</p>
				<p>Haal intussen je E-finder van het netstroom af en sluit deze opnieuw aan om de batterij op te laden.</p>

				<v-btn :loading="saving" block dark depressed large color="primary" @click="gotoOverview()" class="mt-4">
					Naar de kaart
				</v-btn>

			</v-container>
		</v-content>
	</div>
</template>

<script>
  export default {
    computed: {
      device() {
        return this.$store.getters.device;
      },
    },
    data() {
      return {

      };
    },
    methods: {
      showMenu() {
        this.$store.dispatch('toggleMainMenu');
      },
      gotoOverview() {
        this.$router.push({name: 'devices.index'});
      },
      checkForBleService() {
        if(typeof ble === 'undefined') return false;
        // ble.isEnabled(() => this.enableBle(), () => this.disableBle());
      },
      searchForDevice() {
        if(typeof ble === 'undefined') return false;
        this.scanning = true;
        this.hasScanned = true;

        ble.startScan([], (device) => {
          if(!device.name || !device.id) return;

          if(device.advertising && device.advertising.kCBAdvDataLocalName)
            device.name = device.advertising.kCBAdvDataLocalName;

          if(device.name.substr(-6) == this.device.eid.substr(-6)) {
            ble.stopScan();
            this.connectDevice(device.id);
          }
        });

        setTimeout(ble.stopScan, 5000,
          () => this.scanning = false,
          () => this.scanning = false
        );
      },

      connectDevice(deviceId) {
        if(typeof ble === 'undefined') return false;

        ble.connect(deviceId, (device) => {
          // if (!this.validateDevice(device)) return;
          this.bleDevice = device;
        });
      },
    },
    created() {
      this.$store.dispatch('selectDevice', this.$route.params.id);
      this.checkForBleService();
      checkForBleServiceInterval = setInterval(this.checkForBleService, 3000);
    },
    beforeDestroy() {
      if(typeof ble === 'undefined') return;
      ble.stopScan();
      clearInterval(checkForBleServiceInterval);
    }
  };
</script>

<style lang="stylus">
	.uf-form
		position: relative
		background-color: #f2f2f2

	.item-group
		background-color: #fff
		border-top: solid 1px #ddd
		border-bottom: solid 1px #ddd
</style>
